var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',[_c('div',{staticClass:"grid-content"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"alt":"","src":require("@/assets/logo.png")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }